module.exports = __webpack_public_path__ + "img/project-xiaochengxucode.088ff1dd.png";